import React, { useContext } from "react";
import Select from "../ui/Select/Select";
import GlobalsContext from "../context/GlobalsContext";
import { hasAnyCategoryAccess } from "../utils/perm.js";

const CategoriesSelect = ({ value, group, withGroups, ...props }) => {
  const globals = useContext(GlobalsContext);
  const disabled = !hasAnyCategoryAccess(globals.permissions) || props.disabled;

  const intValue = parseInt(value);

  let options;

  if (group === undefined) {
    if (withGroups) {
      options = globals.categories_with_groups;
    } else {
      options = globals.categories;
    }
  } else {
    options = globals.categories.filter(cat => group.includes(cat.group));
  }

  return (
    <Select
      {...props}
      options={options}
      disabled={disabled}
      value={intValue}
      searchable={true}
    />
  );
};

export default CategoriesSelect;
